import { Cancel as CancelIcon } from '@mui/icons-material';

const Cancel = (): JSX.Element => <CancelIcon fontSize="inherit" />;

export default Cancel;
